import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 28,
	viewBox: "0 0 22 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.76218 4.45767L2.76133 4.44738L2.76462 4.4376L2.86325 4.1444L2.87034 4.12333L2.89073 4.11448L3.16808 3.99408L3.1776 3.98994H3.18799H19.7506H19.761L19.7704 3.99404L20.0492 4.11444L20.0696 4.12328L20.0767 4.1444L20.1754 4.4376L20.1786 4.44738L20.1778 4.45767L18.2885 27.2713L18.2885 27.2715C18.2689 27.4975 18.0843 27.6634 17.8613 27.6634H5.07731C4.85616 27.6634 4.66825 27.498 4.65149 27.271C4.65148 27.271 4.65147 27.2709 4.65147 27.2708L2.76218 4.45767ZM3.65298 4.85047L5.47132 26.8166H17.4673L19.2857 4.85047H3.65298Z",
			fill: "#272525",
			stroke: "black",
			strokeWidth: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3413 4.85054H1.37871C1.14071 4.85054 0.95 4.65362 0.95 4.41347C0.95 4.18575 1.14186 3.99001 1.37871 3.99001H21.3413C21.577 3.99001 21.7687 4.18587 21.7687 4.41347C21.7687 4.6535 21.5781 4.85054 21.3413 4.85054Z",
			fill: "#272525",
			stroke: "black",
			strokeWidth: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4691 25.6104C11.2335 25.6104 11.0418 25.4145 11.0418 25.187V7.05362C11.0418 6.81357 11.2324 6.61669 11.4691 6.61669C11.7074 6.61669 11.8965 6.81369 11.8965 7.05362V25.187C11.8965 25.4144 11.7062 25.6104 11.4691 25.6104Z",
			fill: "#272525",
			stroke: "black",
			strokeWidth: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6729 25.5833H14.6827C14.9045 25.5833 15.0888 25.4024 15.1085 25.1916L15.1085 25.1913L15.1085 25.1913L16.6925 7.12462L16.6926 7.1243C16.7119 6.88534 16.5405 6.67327 16.3036 6.65687C16.0708 6.62737 15.8604 6.81044 15.8395 7.04922L14.2569 25.1156C14.2569 25.1157 14.2569 25.1157 14.2569 25.1158L14.2569 25.1159L14.3067 25.1203C14.288 25.3203 14.4413 25.5067 14.6507 25.5203L14.6729 25.5833ZM14.6729 25.5833L14.6638 25.5796L14.6391 25.5695L14.6729 25.5833Z",
			fill: "#272525",
			stroke: "black",
			strokeWidth: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.26728 25.5833L8.27637 25.5796L8.30105 25.5695C8.533 25.5497 8.70416 25.3409 8.68322 25.1157L8.68324 25.1159L8.63343 25.1203L8.68321 25.1156L8.26728 25.5833ZM8.26728 25.5833H8.25745C8.03597 25.5833 7.8498 25.4026 7.83166 25.1912M8.26728 25.5833L7.83166 25.1912M7.83166 25.1912L7.88147 25.1869L7.83167 25.1913L7.83166 25.1912ZM7.09928 7.04955L7.04944 7.05359L7.09925 7.04922L7.09926 7.04936C7.09927 7.04942 7.09927 7.04948 7.09928 7.04955Z",
			fill: "#272525",
			stroke: "black",
			strokeWidth: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.836 4.85054C14.598 4.85054 14.4074 4.65361 14.4074 4.41347V2.02708C14.4074 1.90859 14.3093 1.81041 14.1854 1.81041H8.53473C8.40933 1.81041 8.31136 1.90876 8.31136 2.02708V4.41347C8.31136 4.65349 8.12217 4.85054 7.88271 4.85054C7.64593 4.85054 7.45537 4.6535 7.45537 4.41347V2.02708C7.45537 1.43971 7.93901 0.950008 8.53473 0.950008H14.1854C14.7811 0.950008 15.2647 1.43971 15.2647 2.02708V4.41347C15.2647 4.65362 15.074 4.85054 14.836 4.85054Z",
			fill: "#272525",
			stroke: "black",
			strokeWidth: .1
		})
	]
});
export { SvgDelete as ReactComponent };
